import { render, staticRenderFns } from "./DashboardRDM.vue?vue&type=template&id=3b94202a&scoped=true"
import script from "./DashboardRDM.vue?vue&type=script&lang=js"
export * from "./DashboardRDM.vue?vue&type=script&lang=js"
import style0 from "./DashboardRDM.vue?vue&type=style&index=0&id=3b94202a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b94202a",
  null
  
)

export default component.exports